// extracted by mini-css-extract-plugin
export default {"section":"Layout_section__uNW8I","container":"Layout_container__ezy7n","content":"Layout_content__wwf65","link":"Layout_link__wW4FU"};